import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "filled-file-icon--sprite",
  "use": "filled-file-icon--sprite-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"filled-file-icon--sprite\"><g clip-path=\"url(#filled-file-icon--sprite_a)\"><path d=\"m2 5.333 4.002-4h7.33a.67.67 0 0 1 .668.662v12.01a.662.662 0 0 1-.662.662H2.662A.666.666 0 0 1 2 13.995V5.333Zm4.667-3L3 6h3.667V2.333Z\" fill=\"#5D679C\" /></g><defs><clipPath id=\"filled-file-icon--sprite_a\"><path fill=\"#fff\" d=\"M0 0h16v16H0z\" /></clipPath></defs></symbol>"
});
var result = sprite.add(symbol);
export default symbol